import zDialogo from "@/components/zDialogo";
import zDialogoSimNao from "@/components/zDialogoSimNao";
import zMensagem from "@/components/zMensagem";
import zLoading from "@/components/zLoading";
import zAguardar from "@/components/zAguardar";
import zCampoValor from "@/components/zforms/zCampoValor";
import zDatePicker from "@/components/zDatePicker";
import zDateRangePicker from "@/components/zDateRangePicker";
import zDatePickerMenu from "@/components/zforms/zDatePickerMenu";
import zDateNavigation from "@/components/zDateNavigation";
import zBusca from "@/components/zBusca";
import zCpfCnpj from "@/components/zCpfCnpj";
import zCep from "@/components/zforms/zCep";
import zToolbarDynamicMenu from "@/components/zToolbarDynamicMenu";
import zNotificacao from "@/components/zNotificacao";
import zContainer from "@/components/zContainer";
import zMenuImpressoes from "@/components/zMenuImpressoes";
import zSelect from "@/components/zforms/zSelect";
import zDialogoIntervaloData from "@/components/zDialogoIntervaloData";
import zCentralizedToolbar from "@/components/zCentralizedToolbar";
import zVisibility from "@/components/zVisibility";
import zDev from "@/components/zDev";
import zSplitter from "@/components/zSplitter";

import zTextFieldSearch from '@/components/zforms/zTextFieldSearch';
import zTextField from "@/components/zforms/zTextField";
import zTextarea from "@/components/zforms/zTextarea";
import zTelefone from "@/components/zforms/zTelefone.vue";

import zExpansionConfig from '@/components/config/zExpansionConfig'
import zExpansionConfigItem from '@/components/config/zExpansionConfigItem'

import zDialogoImpressao from '@/components/zDialogoImpressao'
import zDelete from '@/components/zDelete'
import zCompartilharContas from '@/components/zCompartilharContas'
import zCadastroDrawer from '@/components/zCadastroDrawer'
import zEmptyState from '@/components/zEmptyState.vue';
import zToast from '@/components/zToast.vue';
import zBigNumber from '@/components/zBigNumber.vue';
import zCountDown from '@/components/zCountDown.vue';

export default new (class ZComponents {
  install(Vue, options) {
    Vue.component("zDialogo", zDialogo);
    Vue.component("zDialogoSimNao", zDialogoSimNao);
    Vue.component("zMensagem", zMensagem);
    Vue.component("zLoading", zLoading);
    Vue.component("zAguardar", zAguardar);
    Vue.component("zCampoValor", zCampoValor);
    Vue.component("zDatePicker", zDatePicker);
    Vue.component("zDateRangePicker", zDateRangePicker);
    Vue.component("zDatePickerMenu", zDatePickerMenu);
    Vue.component("zDateNavigation", zDateNavigation);
    Vue.component("zBusca", zBusca);
    Vue.component("zCpfCnpj", zCpfCnpj);
    Vue.component("zCep", zCep);
    Vue.component("zToolbarDynamicMenu", zToolbarDynamicMenu);
    Vue.component("zNotificacao", zNotificacao);
    Vue.component("zContainer", zContainer);
    Vue.component("zMenuImpressoes", zMenuImpressoes);

    Vue.component("zTextFieldSearch", zTextFieldSearch);
    Vue.component("zTextField", zTextField);
    Vue.component("zTextarea", zTextarea);
    Vue.component("zTelefone", zTelefone);
    Vue.component("zSelect", zSelect);
    Vue.component("zDialogoIntervaloData", zDialogoIntervaloData);
    Vue.component("zCentralizedToolbar", zCentralizedToolbar);
    Vue.component("zVisibility", zVisibility);
    Vue.component("zDev", zDev);
    Vue.component("zSplitter", zSplitter);

    Vue.component('zExpansionConfig', zExpansionConfig);
    Vue.component('zExpansionConfigItem', zExpansionConfigItem);

    Vue.component('zDialogoImpressao', zDialogoImpressao);
    Vue.component('zDelete', zDelete);
    Vue.component('zCompartilharContas', zCompartilharContas);
    Vue.component('zCadastroDrawer', zCadastroDrawer);
    Vue.component('zEmptyState', zEmptyState);
    Vue.component('zToast', zToast);
    Vue.component('zBigNumber', zBigNumber);
    Vue.component('zCountDown', zCountDown);
  }
})();


// import Vue from 'vue'

// // https://webpack.js.org/guides/dependency-management/#require-context
// const requireComponent = require.context(
//   // Look for files in the current directory
//   '.',
//   // Do not look in subdirectories
//   false,
//   // Only include "_base-" prefixed .vue files
//   /_base-[\w-]+\.vue$/
// )

// // For each matching file name...
// requireComponent.keys().forEach((fileName) => {
//   // Get the component config
//   const componentConfig = requireComponent(fileName)
//   // Get the PascalCase version of the component name
//   const componentName = fileName
//     // Remove the "./_" from the beginning
//     .replace(/^\.\/_/, '')
//     // Remove the file extension from the end
//     .replace(/\.\w+$/, '')
//     // Split up kebabs
//     .split('-')
//     // Upper case
//     .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
//     // Concatenated
//     .join('')

//   // Globally register the component
//   Vue.component(componentName, componentConfig.default || componentConfig)
// })